import  styles from "./FilterAlertsMobile.module.scss";
import ModalFilters from "components/MainApp/organisms/Modals/ModalFilters/ModalFilters";
import filtersIcon from "assets/images/filters-icon.svg";
import { useState } from "react";

const FilterAlertsMobile = ({ filters, devices, isTablet }) => {
  const [isOpenPopUp, setIsOpenPopUp] = useState(false);

  const filtersCount =
    (filters?.list?.devices && filters.list?.devices.length > 0 ? 1 : 0) +
    (filters?.list?.status && filters.list?.status.length > 0 ? 1 : 0) +
    (filters?.list?.dateRange ? 1 : 0)

  const handleOpenFilters = () => {
    setIsOpenPopUp(true);
  };

  return (
    <div className={styles["filter-alerts-mobile"]}>
      <button onClick={handleOpenFilters}>
        <img src={filtersIcon} />
        {filtersCount > 0 && <span>{filtersCount}</span>}
      </button>

      <ModalFilters
        isOpen={isOpenPopUp}
        setIsOpen={setIsOpenPopUp}
        filters={filters}
        devices={devices}
        isTablet={isTablet}
      />
    </div>
  );
};

export default FilterAlertsMobile;
